import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=a3e95edc&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=a3e95edc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e95edc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3e95edc')) {
      api.createRecord('a3e95edc', component.options)
    } else {
      api.reload('a3e95edc', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=a3e95edc&scoped=true&", function () {
      api.rerender('a3e95edc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25CGkOgM64KMW/JS/comp/DocBox.vue"
export default component.exports